import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
} from '@mui/material'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { useUserContext } from '../../../Contexts/UserConfig'
import {
  useVesselContext,
  vesselDialogs,
  VesselViewFields,
} from '../../../Contexts/Modules/SampleModule/VesselModule'

function NewStatusDialog() {
  const { fields, setFields, openDialog, setOpenDialog } = useVesselContext()
  const { loginConfig, loadingConfig } = useUserContext()
  return (
    <Dialog
      open={openDialog === vesselDialogs.STATUS}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Select the new status'}</DialogTitle>
      <DialogContent>
        <Select
          fullWidth
          name="vesselStatus"
          value={fields?.vesselStatus || ''}
          onChange={(e: any) => {
            setFields((fields: VesselViewFields) => ({
              ...fields,
              vesselStatus: e.target.value,
            }))
            setOpenDialog(vesselDialogs.STATUS_CONFIRM)
          }}
        >
          {listFromCodes(loginConfig, 'SampleStatusID', loadingConfig)}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NewStatusDialog
